import React, { useMemo } from 'react';
import { Grid } from '@material-ui/core';
import { css } from '@emotion/react';
import { colors } from '@/styles';
import ZipListItem from './ZipListItem';
import SearchInput from '../misc/SearchInput';

const ZipList = ({ subregion, loading, zips, filter, callbacks, carriers, carriersById, options }) => {
    const list = useMemo(() => {
        if (!zips) {
            return [];
        }

        return zips.filter((zip) => {
            return !filter.zip || zip.zip.toLowerCase().includes(filter?.zip.toLowerCase());
        });
    }, [zips, filter]);

    return (
        <>
            <Grid
                container
                direction="row"
                css={css`
                    flex: 0;
                    flex-basis: 0;
                    padding: 12px 20px;
                `}
            >
                <SearchInput
                    placeholder="Search Zips"
                    onChange={(search) => callbacks.setFilter((prev) => ({ ...prev, zip: search }))}
                />
            </Grid>
            <Grid
                container
                direction="row"
                css={css`
                    flex: 1;
                    flex-basis: 0;
                    overflow-y: scroll;
                    border-top: 1px solid ${colors.greys[4]};
                `}
            >
                <Grid container direction="column">
                    {list.map((zip, idx) => {
                        return (
                            <ZipListItem key={zip.zip} zip={zip} idx={idx} callbacks={callbacks} options={options} />
                        );
                    })}
                </Grid>
            </Grid>
        </>
    );
};

export default ZipList;
